import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, ModuleGuard } from '../../../core/auth';
import {
  FormListComponent,
  TemplateListComponent,
  FormTemplateMapListComponent,
} from './components';

const routes: Routes = [
  {
    path: 'forms',
    canActivate: [AuthGuard, ModuleGuard],
    data: { permissionName: 'accessToForms' },
    component: FormListComponent,
  },
  {
    path: 'templates',
    canActivate: [AuthGuard, ModuleGuard],
    data: { permissionName: 'accessToDocumentTemplates' },
    component: TemplateListComponent,
  },
  {
    path: 'mapping',
    canActivate: [AuthGuard, ModuleGuard],
    data: { permissionName: 'accessToFormTemplateMapping' },
    component: FormTemplateMapListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FormsTemplatesRoutingModule {}
